import React, { useState } from "react";
import {
  Card,
  CardContent,
  CardMedia,
  Typography,
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton
} from "@mui/material";
import { Info, Share, WhatsApp, Close } from "@mui/icons-material";
import './CommonCard.css';
const CommonCard = ({ val: val2, cat,siteData, s3_site_url, renderSymbol, handleShare }) => {
  const val = { ...val2, origPrice: parseFloat(val2.origPrice), price: parseFloat(val2.price) };
  const [open, setOpen] = useState(false);
//   const s3_site_url = 'https://d6-halo.s3.us-east-2.amazonaws.com/static/media/';

  const discount =
    val.origPrice > val.price
      ? Math.round(((val.origPrice - val.price) / val.origPrice) * 100)
      : 0;

  return (
    <>
      <Card
      
        className="product-card"
        style={{ display: "flex", flexDirection: "column", height: "100%" }}
      >
        <CardMedia
         onClick={() => setOpen(true)} 
          component="img"
          height="140"
          image={`${s3_site_url}products/${val.imageN}`}
          title={val.name}
        />
        <CardContent style={{ display: "flex", flexDirection: "column", flexGrow: 1 }}>
          
          <div onClick={() => setOpen(true)} >
          <Typography style={{ minHeight: 40 }} variant="body2">
            {val.name}
          </Typography>

          <Typography
            variant="body2"
            style={{
              padding: "1vh 0px",
              color: "gray",
              flex: 1,
              display: "-webkit-box",
              WebkitLineClamp: 3,
              WebkitBoxOrient: "vertical",
              overflow: "hidden",
              textOverflow: "ellipsis",
              minHeight: 65
            }}
          >
            {val?.description?.length > 100
              ? val.description.slice(0, 100) + "..."
              : val.description}
          </Typography>
</div>
          <div onClick={() => setOpen(true)}  style={{ display: "flex", alignItems: "center", paddingTop: "1vh" }}>
            {val.origPrice > val.price && (
              <Typography
                variant="body2"
                style={{ textDecoration: "line-through", color: "gray", marginRight: "8px" }}
              >
                {renderSymbol}
                {val.origPrice}
              </Typography>
            )}

            <Typography variant="h6" style={{ color: "green", marginRight: "8px" }}>
              {renderSymbol}
              {val.price > 0 ? val.price : val.origPrice}
            </Typography>

            {discount > 0 && (
              <Typography variant="body2" style={{ color: "red" }}>
                ({discount}% OFF)
              </Typography>
            )}
          </div>

          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              width: "100%",
              paddingRight: "10px",
              paddingTop: "5px"
            }}
          >
              <Info onClick={() => setOpen(true)} style={{ color: "gray" }} />
            <div>
              <WhatsApp
                onClick={() =>
                  window.open(
                    `https://wa.me/91${val.whatsapp}?text=Hello%20${siteData?.siteName},%20I%20am%20interested%20in%20your%20${val.name}%20product`
                  )
                }
                style={{ color: "var(--gcolor)", paddingRight: "10px", cursor: "pointer" }}
              />
              <Share onClick={() => handleShare(val.share)} style={{ cursor: "pointer" }} />
            </div>
          </div>
        </CardContent>
      </Card>

      <Dialog
        open={open}
        onClose={() => setOpen(false)}
        maxWidth="sm"
        fullWidth
        scroll="paper"
      >
        <DialogTitle style={{ display: "flex", justifyContent: "space-between" }}>
          {val.name}
            <Close onClick={() => setOpen(false)}/>
        </DialogTitle>

       <DialogContent
  dividers
  style={{
    maxHeight: "70vh",
    overflowY: "auto",
    position: "relative" // Needed for chip positioning
  }}
>
  <div style={{ position: "relative" }}>
    <img
      src={`${s3_site_url}products/${val.imageN}`}
      alt={val.name}
      style={{ width: "100%", borderRadius: 8, marginBottom: 16 }}
    />

  
    {cat && (
      <div
        style={{
          position: "absolute",
          bottom: "45px",
          left: "10px",
          backgroundColor: "white",
          color: "black",
          padding: "6px 18px",
          borderRadius: "16px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
          fontSize: "0.85rem",
          fontWeight: "bold"
        }}
      >
        {cat}
      </div>
    )}
  </div>

  <Typography variant="body1" className="dialog_description" gutterBottom>
    {val.description}
  </Typography>

  <Typography
    variant="body2"
    className="dialog_original_price"
    style={{ marginTop: 16 }}
  >
    <b>Original Price :</b>{" "}
    <span style={{ textDecoration: "line-through", color: "gray" }}>
      {renderSymbol}
      {val.origPrice}
    </span>
  </Typography>

  <Typography className="dialog_original_price" variant="body2">
    <b>Discounted Price :</b>{" "}
    <span style={{ color: "green", fontWeight: "bold" }}>
      {renderSymbol}
      {val.price}
    </span>
  </Typography>

  {discount > 0 && (
    <Typography
      className="dialog_you_save"
      variant="body2"
      style={{ color: "red" }}
    >
      You save <b>{discount}% ({renderSymbol}
      {val.origPrice - val.price} OFF)</b>
    </Typography>
  )}

  {val.additionalInfo && (
    <Typography
      variant="body2"
      className="dialog_original_price"
      style={{ marginTop: 16 }}
    >
      <b>Additional Information</b>
    </Typography>
  )}

  {val.additionalInfo && (
    <div
      dangerouslySetInnerHTML={{ __html: val.additionalInfo }}
      style={{ padding: 10 }}
    />
  )}

  <div style={{ display: "flex", justifyContent: "flex-end", marginTop: 16 }}>
    <WhatsApp
      onClick={() =>
        window.open(
          `https://wa.me/91${val.whatsapp}?text=Hello%20${siteData?.siteName},%20I%20am%20interested%20in%20your%20${val.name}%20product`
        )
      }
      style={{
        color: "var(--gcolor)",
        paddingRight: "10px",
        cursor: "pointer",
        fontSize: "2rem"
      }}
    />
    <Share
      onClick={() => handleShare(val.share)}
      style={{ cursor: "pointer", fontSize: "2rem" }}
    />
  </div>
</DialogContent>

      </Dialog>
    </>
  );
};

export default CommonCard;
